import React from "react";
import cn from "classnames";
import { Icon } from "@components/atoms/icon/icon";
import { ToolTip } from "../tooltip/tooltip";
import styles from "./support-ticket-button.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import {
  updateAddRequestTechnicalSupportDrawerModalWithoutMachine,
  updateModalsCloseDrawerModal,
} from "@src/reducers/your-reducer";

interface SupportTicketButtonPropTypes {
  content: string;
  ariaLabel: string;
  iconName?: string;
  height?: number;
  width?: number;
}

const DEFAULT_ICON_NAME = "support_ticket";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;

const cssClassName = "support-ticket-button";

export const SupportTicketButton = ({
  content,
  ariaLabel,
  iconName = DEFAULT_ICON_NAME,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
}: SupportTicketButtonPropTypes) => {
  const dispatch = useDispatch();

  const isAddRequestTechnicalSupportDrawerModalWithoutMachineOpen = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.addRequestTechnicalSupportDrawerModalWithoutMachine
        .showModal,
  );

  const toggleSupportTicketDrawer = () => {
    dispatch(updateAddRequestTechnicalSupportDrawerModalWithoutMachine({}));
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: false,
        id: "supportChatDrawerModal",
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: !isAddRequestTechnicalSupportDrawerModalWithoutMachineOpen,
        id: "addRequestTechnicalSupportDrawerModalWithoutMachine",
      }),
    );
  };

  return (
    <ToolTip position={"bottom"} content={content}>
      <button
        type="button"
        className={cn(
          styles[cssClassName],
          styles[`${cssClassName}__hover`],
          styles[`${cssClassName}__center-content`],
        )}
        onClick={toggleSupportTicketDrawer}
        aria-label={ariaLabel}
      >
        <Icon name={iconName} width={width} height={height} />
      </button>
    </ToolTip>
  );
};
